var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1603(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.091,
    height: 12,
    viewBox: "0 0 16.091 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1603",
    "data-name": "Group 1603",
    transform: "translate(508.565 -176.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3977",
    "data-name": "Path 3977",
    d: "M-502.521,184.576a2.017,2.017,0,0,1,.147-.195q3.663-3.666,7.328-7.329a.806.806,0,0,1,1.076-.153,1.112,1.112,0,0,1,.154.133q.534.532,1.066,1.066a.8.8,0,0,1,0,1.208q-4.585,4.587-9.172,9.172a.8.8,0,0,1-1.22,0l-5.13-5.13a.8.8,0,0,1,0-1.241q.515-.517,1.033-1.033a.806.806,0,0,1,1.242,0q1.667,1.664,3.331,3.331C-502.627,184.439-502.594,184.487-502.521,184.576Z",
    transform: "translate(0)",
    fill: "#d10a11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1603);
export default __webpack_public_path__ + "static/media/Group 1603.6d0f8d8cf93a88c44d8799acfb081f8a.svg";
export { ForwardRef as ReactComponent };